module.exports = __webpack_public_path__ + "media/images/og-96b245cce4c545c7bc60a7975e834ca3.jpg";